import React from 'react';
import { Link } from 'react-router-dom';

export default function FirstEquityLogo({ className, link = true }) {
  const image = (
    <img
      src="/images/firstequity.png"
      alt="First Equity Credit Union"
      className={className || 'h-14 md:h-16 lg:h-20 w-auto max-w-[320px] transition-all duration-300'}
    />
  );

  if (!link) {
    return image;
  }

  return (
    <Link to="/" className="flex items-center">
      {image}
    </Link>
  );
} 